<div odxLayout="flex vertical-center" class="space-between">
  @if (gas) {
    <div>
      <p class="odx-title-6 header-title">{{ gas | localizeGasName }}</p>
      <p class="odx-subtitle-6">{{ gas.id }}</p>
    </div>
  }
  @if (product) {
    <div odxLayout="flex vertical-center">
      <div class="image-wrapper">
        <app-product-image [product]="product" [iconSize]="'56px'"></app-product-image>
      </div>
      <div>
        <p class="odx-title-6 header-title" [odxTooltip]="product | localizeProductName">{{ product | localizeProductName }}</p>
        <p class="odx-subtitle-6">{{ dimensions ? product.id + ", " + dimensions : product.id }}</p>
      </div>
    </div>
  }
  @if (product && showCosts && priceData) {
    <p class="odx-text">
      {{ priceData.price | currency: priceData.currencyCode }}
    </p>
  }
</div>
